/**
 * Klucz w localStorage, pod którym trzymamy wybrany język interfejsu.
 * Cache na czas startu — źródłem prawdy jest preferencja zapisana na koncie (User.PreferredLanguage).
 */
export const USER_LANG_STORAGE_KEY = "userLang";

/**
 * [A15-02] Zdarzenie okna emitowane przy KAŻDEJ zmianie języka.
 *
 * Zapis do localStorage nie powoduje żadnej notyfikacji w tej samej karcie (natywne `storage`
 * leci wyłącznie do POZOSTAŁYCH kart), więc potrzebny jest własny sygnał — inaczej komponenty,
 * które liczą coś na podstawie języka przy renderze (przede wszystkim tablica tras w App.js),
 * nie mają jak się dowiedzieć, że język się zmienił.
 */
export const USER_LANG_CHANGED_EVENT = "userlang-changed";

/**
 * Zwraca aktualny język routingu: "pl" lub "en".
 * Dla polskiego → ścieżki polskie, dla każdego innego → angielskie.
 */
export function getRouteLang() {
    const lang = localStorage.getItem(USER_LANG_STORAGE_KEY) || "pl";
    return lang === "pl" ? "pl" : "en";
}

/**
 * [A15-02] Jedyne miejsce, w którym wolno zapisać wybrany język.
 *
 * Co było źle: język zapisywano bezpośrednio przez `localStorage.setItem("userLang", …)`.
 * Tablica tras w App.js jest budowana przy renderze App (`routePath(...)` czyta język na żywo),
 * a `<App/>` to stały element z index.js — po montażu nigdy się nie przerenderowuje. Trasy
 * zostawały więc ZAMROŻONE w języku z chwili startu aplikacji.
 * Skutek dla użytkownika: po przełączeniu flagi (albo po zalogowaniu na konto z
 * PreferredLanguage='en', gdzie przeglądarka startowała po polsku) `localizedPath('dashboard')`
 * dawał '/dashboard', którego nie było w tablicy tras → catch-all '/:slug' → LocalizedRedirect
 * → '/' → HomeRedirect → znowu '/dashboard'. Pętla przekierowań kończyła się białym ekranem
 * („Maximum update depth exceeded") do ręcznego F5.
 * Dlaczego tak naprawione: zapis dokłada sygnał, na który App reaguje przerenderowaniem i
 * przelicza trasy w nowym języku. Świadomy fallback z przeładowaniem strony (Header, gdy widget
 * Google Translate nie przełączy się w miejscu) zostaje nietknięty — po reloadzie trasy i tak
 * budują się od zera.
 */
export function setUserLang(lang) {
    localStorage.setItem(USER_LANG_STORAGE_KEY, lang);
    try {
        window.dispatchEvent(new Event(USER_LANG_CHANGED_EVENT));
    } catch {
        /* środowisko bez window — nikt nie nasłuchuje, zapis i tak się udał */
    }
}
